import AssignedUsersCell from './AssignedUsersCell'
import CellWithTooltip from './CellWithTooltip'
import CheckboxCell from './CheckboxCell'
import ContentLibraryCell from './ContentLibraryCell'
import DescriptionPreviewCell from './DescriptionPreviewCell'
import DisplayNameWithFirmNameCell from './DisplayNameWithFirmNameCell'
import EditableCheckboxCell from './EditableCheckboxCell'
import ImportCatalogButtonCell from './ImportCatalogButtonCell'
import ImportDocButtonCell from './ImportDocButtonCell'
import IsActiveCell from './IsActiveCell'
import LastScrapedCell from './LastScrapedCell'
import MultiValueCellWithTooltip from './MultiValueCellWithTooltip'
import ProductNameCell from './ProductNameCell'

const tableCell: Record<string, (prop: any) => JSX.Element> = {
    categories: MultiValueCellWithTooltip,
    hasManufacturerOptions: CheckboxCell,
    canAutoGenerateProductSpecification: EditableCheckboxCell,
    isActive: IsActiveCell,
    displayNameWithFirmName: DisplayNameWithFirmNameCell,
    productName: ProductNameCell,
    partnershipLinksBIM: CellWithTooltip,
    partnershipLinksSM: CellWithTooltip,
    partnershipLinksULE: CellWithTooltip,
    partnershipLinksSwatchbox: CellWithTooltip,
    firmLogoUrl: CellWithTooltip,
    contentLibrary: ContentLibraryCell,
    fullLengthDoc: ImportDocButtonCell,
    importCatalog: ImportCatalogButtonCell,
    updatedLastAiScrapeDate: LastScrapedCell,
    description: DescriptionPreviewCell,
    assignedContactUsers: AssignedUsersCell,
    assignedBPMUsers: AssignedUsersCell,
    assignedDeltekUsers: AssignedUsersCell,
}

export default tableCell
